import { render, staticRenderFns } from "./CommunicationComposer.vue?vue&type=template&id=f55337f0"
import script from "./CommunicationComposer.vue?vue&type=script&lang=js"
export * from "./CommunicationComposer.vue?vue&type=script&lang=js"
import style0 from "./CommunicationComposer.vue?vue&type=style&index=0&id=f55337f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports